import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';

import type { CaseInvestigationTrackerRow } from '../models/case-investigation-tracker-row.model';
import type { TableQuery } from '../../../shared/components/generic-table/models/table-query.model';

export interface TableDataResponse<T> {
  readonly data: readonly T[];
  readonly totalRecords: number;
}

export interface CaseInvestigationTrackerClient {
  getRows(query: TableQuery): Observable<TableDataResponse<CaseInvestigationTrackerRow>>;
}

export const CASE_INVESTIGATION_TRACKER_CLIENT = new InjectionToken<CaseInvestigationTrackerClient>(
  'CASE_INVESTIGATION_TRACKER_CLIENT'
);
